//Config const
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://inventario-api.sivop.cl/api' : 'http://localhost:3000/api';

